import React     from 'react'
import PropTypes from 'prop-types'

import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import CanteenRepository, { Canteen }       from 'alto-react-canteen/lib/models'

class CanteenTable extends AdminTable
  model: Canteen

  columns: ->
    [{
       property: 'registerNumber'
       header:
         label: 'Číslo'
         props: { className: 'narrow-column' }
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'name'
       header:
         label: 'Název'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }]

class CanteenForm extends AdminForm
  model:      Canteen
  createText: 'Registrovat'

  defaultValues:
    name: ''

  inputs: ->
    [{
      label:         'Název'
      property:      'name'
      validator:     'notEmpty'
    }, {
      type:          'smallint'
      label:         'Číslo'
      property:      'registerNumber'
      allowNegative: true
    }, {
      type:          'textarea'
      label:         'Rozlišovací HTML'
      property:      'discriminatorHTML'
    }, {
      type:          'smallint'
      label:         'Výška rozlišovacího HTML'
      property:      'discriminatorHeight'
    }]

export default class CanteenManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  relation: ->
    @__repository ||= CanteenRepository.forBackend(@context.backend)
    @__relation   ||= @__repository.canteens

  tableComponent: CanteenTable
  formComponent:  CanteenForm
